import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'call-flow-configurations',
  templateUrl: './call-flow-configurations.component.html',
  styleUrls: ['./call-flow-configurations.component.scss']
})
export class CallFlowConfigurationsComponent implements OnInit {

  callFlowItems: any[];

  constructor() {
    this.callFlowItems = [
      {routerLink: 'normalizationGroups', name: 'normalization groups'},
      {routerLink: 'normalizationBeforeRouting', name: 'normalization before routing'},
      {routerLink: 'prefixGroups', name: 'prefix groups'},
      {routerLink: 'policyStudio', name: 'policy studio'},
      {routerLink: 'webServices', name: 'web services'},
      {routerLink: 'sipConditionGroups', name: 'SIP condition Groups'},
      {routerLink: 'sipManipulationGroups', name: 'SIP manipulation Groups'}
    ];
  }

  ngOnInit(): void {
  }

}
